import React from "react";
import { StyledRange } from "./styled";

interface Props {
  title: string;
  max?: number;
  min?: number;
  value: number;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
  name: string;
}

const Range: React.FC<Props> = ({
  title,
  max = 50,
  min = 10,
  value,
  onChange,
  name,
}) => {
  return (
    <StyledRange>
      <label htmlFor={name}>{title}</label>

      <input
        value={value}
        name={name}
        type="range"
        max={max}
        min={min}
        onChange={onChange}
      />
    </StyledRange>
  );
};

export default Range;
